import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Modal,
  Spinner,
} from "react-bootstrap";
import divider from "../assets/bg/divider.png";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import GetContacts from "../actions/support/GetContacts";
import { Avatar, CircularProgress, TextareaAutosize } from "@mui/material";
import Contact from "../actions/support/Contact";
import { Toast } from "react-bootstrap";
import contactcover from "../assets/images/contact-cover.svg";
import DetectDevice from "../data/DetectDevice";
import SimpleNotificationModal from "./modals/SimpleNotificationModal";
import { Height } from "@material-ui/icons";
import "../assets/css/contactPage.css";
import { useDefaultContext } from "./context/DefaultContext";

const ContactSection = ({ topspace }) => {
  const NewContacts = async () => {
    const res = await GetContacts({
      payload: {
        category: "default",
      },
    });

    if (res && res.status === "success") {
      setcontacts(res.data); // Set the contacts data to state
    } else {
      console.error("Failed to fetch contacts:");
    }
  };

  const [ToastTitle, setToastTitle] = useState(null);
  const [ToastMessage, setToastMessage] = useState(null);
  const [toast, settoast] = useState(false);

  const fname = document.getElementById("fname");
  const lname = document.getElementById("lname");
  const email = document.getElementById("email");
  const phone = document.getElementById("phone");
  const [subject, setsubject] = useState("contact");
  const [message, setMessage] = useState(null);
  const [contact, setcontact] = useState(false);
  const [loading, setloading] = useState(false);
  const NewContact = async (e) => {
    e.preventDefault();
    setloading(true);

    if (
      !fname.value ||
      fname.value.trim() === "" ||
      !lname.value ||
      lname.value.trim() === "" ||
      !email.value ||
      email.value.trim() === "" ||
      !phone.value ||
      phone.value.trim() === "" ||
      !subject ||
      subject.trim() === "" ||
      !message ||
      message.trim() === ""
    ) {
      setloading(false);
      setToastTitle("All fields are required!");
      setToastMessage("Please fill in all the fields before submitting.");
      settoast(true);
      return;
    }

    try {
      const res = await Contact({
        payload: {
          username: `${fname.value} ${lname.value}`,
          phone: phone.value,
          email: email.value,
          subject: subject,
          message: message,
        },
      });

      setloading(false);

      if (res.status === "success") {
        setToastTitle("Message sent successfully!");
        setToastMessage(
          "Our support team will reach you within the next 24 hours.",
        );
      } else {
        setToastTitle("Something went wrong!");
        setToastMessage("Please try again after some time.");
      }
      settoast(true);
    } catch (error) {
      setloading(false);
      setToastTitle("Network error!");
      setToastMessage("Please check your connection and try again.");
      settoast(true);
    }
  };

  const [contacts, setcontacts] = useState(null);

  const device = DetectDevice();

  const handleClose = () => {
    settoast(false);
  };

  useEffect(() => {
    NewContacts();
  }, []);
  return (
    <div className="contact-section w-100">
      {" "}
      <div className="toast-container">
        <SimpleNotificationModal
          visibility={toast}
          handleClose={handleClose}
          data={{
            title: ToastTitle,
            description: ToastMessage,
            button_text: "Got It",
          }}
        />
        <Toast
          show={false}
          onClose={() => settoast(false)}
          delay={6000}
          autohide
          className="space-between bg-warning"
        >
          <Toast.Header>
            <img
              src="holder.js/20x20?text=%20"
              className="rounded me-2"
              alt=""
            />
            <strong className="me-auto">{ToastTitle}</strong>
          </Toast.Header>
          <Toast.Body className="text-center">{ToastMessage}</Toast.Body>
        </Toast>
      </div>
      <div className="col-lg-12 sm-p-0 col-md-12 col-sm-12 col-12 mx-auto br-5 sm-br-0  p-0 md-p-3 h-auto">
        {/* 
        <div className={`text-center contact-page-light mb-5 d-none d-sm-block ${topspace ? topspace : null} w-100 bg-warning py-4`} > 
            <h1 className="contact-title text-white pt-5">Get in Touch</h1>
            <p className="contact-subtitle text-white pb-5">
              Have questions about our courses? We're here to help you on your
              learning journey.
            </p>


        </div> */}
        <div className="contact-page position-relative">
          <div className="contact-header contact-siliconMinds-orng">
            <div className="container ">
              <h1 className="contact-title ">Get in Touch</h1>
              <p className="contact-subtitle fw-semibold text-white">
                Have questions about our courses? We're here to help you on your
                learning journey.
              </p>
            </div>
          </div>

          {/* Service Cards Section */}
          {/* Service Cards Section */}
          <div className="service-cards-section container d-none d-lg-block">
            <Container>
              <Row className="g-4">
                {/* Course Inquiries Card */}
                <Col lg={4} md={12} sm={12}>
                  <div className="service-card text-center">
                    <div className="d-flex align-items-center">
                      <div className="service-icon course-icon">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                          <path d="M8 4H24V28H8V4Z" fill="currentColor" opacity="0.3" />
                          <path
                            d="M4 12H8M4 18H8M28 12H24M28 18H24M16 4V28M8 8H24M8 14H24M8 20H24"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                        </svg>
                      </div>
                      <h5 className="service-title">Course Inquiries</h5>
                    </div>
                    <p className="service-description text-start">
                      Learn about our comprehensive courses and programs
                      designed for your success.
                    </p>
                  </div>
                </Col>

                {/* Student Support Card */}
                <Col lg={4} md={12} sm={12}>
                  <div className="service-card">
                    <div className="d-flex align-items-center">
                      <div className="service-icon support-icon">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                          <circle cx="16" cy="16" r="12" fill="currentColor" opacity="0.3" />
                          <path
                            d="M16 8V16L22 22"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <h5 className="service-title">Student Support</h5>
                    </div>
                    <p className="service-description">
                      Get assistance with enrollment, course materials,
                      and learning resources.
                    </p>
                  </div>
                </Col>

                {/* Learning Resources Card */}
                <Col lg={4} md={12} sm={12}>
                  <div className="service-card">
                    <div className="d-flex align-items-center">
                      <div className="service-icon resources-icon">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                          <path d="M6 6H26V26H6V6Z" fill="currentColor" opacity="0.3" />
                          <path
                            d="M10 10V22M22 10V22M10 14H22M10 18H22"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <h5 className="service-title">Learning Resources</h5>
                    </div>
                    <p className="service-description">
                      Access study guides, tutorials and additional
                      learning materials.
                    </p>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>

        </div>

        <div className="flex-wrap  justify-content-center container  d-flex me-0 pe-0 me-auto ">
          <div className="col-lg-6 animate sm-mt-5 col-md-6 col-sm-12 col-12 shadow-none  br-5 text-field p-3 ps-md-lg-xl-xxl-5 ">
            <form onSubmit={(e) => NewContact(e)} className="w-100">
              <div className="text-align-left">
                <h3 className="mt-2 pt-3">
                  <b>Send us a message</b>
                </h3>
                <p className="mb-4">
                  Fill up the form and our team will reach you in 24 hours or
                  call us for immediate support.
                </p>
              </div>
              <div className="d-flex sm-mt-20 justify-content-between">
                <div className="col p-1">
                  <TextField
                    className="rounded-3"
                    id="fname"
                    autoComplete={false}
                    type="text"
                    required
                    label={"First Name"}
                    variant="outlined"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "25px",
                      },
                    }}
                  />
                </div>
                <div className="col p-1">
                  <TextField
                    className="rounded-3"
                    id="lname"
                    autoComplete={false}
                    type="text"
                    required
                    label={"Last Name"}
                    variant="outlined"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "25px",
                      },
                    }}
                  />
                </div>
              </div>
              <div className="d-flex mt-3 justify-content-between">
                <div className="p-1 col">
                  <TextField
                    className="rounded-3"
                    id="email"
                    autoComplete={false}
                    type="email"
                    required
                    label={"Email"}
                    variant="outlined"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "25px",
                      },
                    }}
                  />
                </div>

                <div className="col p-1">
                  <TextField
                    className="rounded-3"
                    id="phone"
                    autoComplete={false}
                    type="number"
                    required
                    label={"Phone"}
                    variant="outlined"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "25px",
                      },
                    }}
                  />
                </div>
              </div>

              <div className="mt-3">
                <div className="p-1">
                  <TextareaAutosize
                    className="rounded-3 h-100 w-100 p-2"
                    id="message"
                    onChange={(e) => setMessage(e.target.value)}
                    minRows={3}
                    required
                    type="text"
                    placeholder="Message..."
                    style={{ borderRadius: "12px", border: "1px solid #ccc" }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "35px",
                      },
                    }}
                  />
                </div>
              </div>
              <div className="mt-3">
                {loading ? (
                  <>
                    <button
                      disabled
                      type="submit"
                      className="btn btn-primary w-100"
                    >
                      <CircularProgress size={18} className="mr-5 text-white" />{" "}
                      Sending...
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      type="submit"
                      className="btn btn-siloconMinds-orng text-light w-100"
                    >
                      Send Message
                    </button>
                  </>
                )}
              </div>
            </form>
          </div>
          <div className="col-lg-6 col-12 ps-lg-2 shadow-none shadow-md position-relative col-md-6 col-sm-12  br-5 sm-br-0 text-white p-3 ms-0 ps-0">
            <div className="contact-info">
              <h4 className="contact-info-title my-3">Contact Information</h4>

              <div className="contact-item">
                <div className="contact-icon email-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M3 8L10.89 13.26C11.54 13.76 12.46 13.76 13.11 13.26L21 8M5 19H19C20.1 19 21 18.1 21 17V7C21 5.9 20.1 5 19 5H5C3.9 5 3 5.9 3 7V17C3 18.1 3.9 19 5 19Z"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div>
                  <label className="contact-label">Email Us</label>
                  <p className="contact-value">info@siliconmindstech.com</p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon phone-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M22 16.92V19.92C22.0025 20.1986 21.9506 20.4742 21.8463 20.7328C21.742 20.9915 21.5865 21.2272 21.3842 21.4226C21.1819 21.6179 20.9363 21.7688 20.6664 21.8667C20.3966 21.9645 20.1085 22.0073 19.82 22C16.3733 21.6326 13.1637 20.2204 10.589 17.941C8.32896 15.9151 6.70554 13.2604 6.00001 10.3624C5.87275 9.88405 5.84562 9.38328 5.92062 8.89358C5.99562 8.40388 6.17065 7.93656 6.43001 7.52126C6.68937 7.10596 7.02747 6.75718 7.42357 6.49395C7.81967 6.23072 8.26468 6.05735 8.71001 6M15 3H19.5C20.0304 3 20.5391 3.21071 20.9142 3.58579C21.2893 3.96086 21.5 4.46957 21.5 5V8M16 13L18 15M5 3H8C8.53043 3 9.03914 3.21071 9.41421 3.58579C9.78929 3.96086 10 4.46957 10 5V8"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div>
                  <label className="contact-label">Call Us</label>
                  <p className="contact-value">+91 9986783238</p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon location-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12 21C8.13401 17.7998 5 14.2543 5 10.5C5 6.35786 8.13401 3 12 3C15.866 3 19 6.35786 19 10.5C19 14.2543 15.866 17.7998 12 21Z"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <circle cx="12" cy="10" r="2" fill="currentColor" />
                  </svg>
                </div>
                <div>
                  <label className="contact-label">Address</label>
                  <p className="contact-value">
                  2nd Floor Dwaraka Plaza, above UCO bank, 
                    <p>Dwaraka nagar main road, Opposite SBI bank, Visakhapatnam, Pin: 530016</p>
                  </p>
                </div>
              </div>

              <div className="office-hours">
                <h5 className="office-hours-title">Office Hours</h5>
                <div className="hours-list">
                  <div className="hour-item">
                    <span>Monday - Friday:</span>
                    <span className="hour-time">9:00 AM - 6:00 PM</span>
                  </div>
                  <div className="hour-item">
                    <span>Saturday:</span>
                    <span className="hour-time">10:00 AM - 4:00 PM</span>
                  </div>
                  <div className="hour-item">
                    <span>Sunday:</span>
                    <span className="hour-time">Closed</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;